<template>
  <v-autocomplete :items="list" :value="setectVale" auto-select-first dense outlined chips clearable hide-details
    hide-selected :item-text="itemText" item-value="uuid" :label="label" :search-input.sync="search"
    @input="changeData($event)"></v-autocomplete>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "AutocompleteSearch",
  props: ["itemText", "itemValue", "storeLink", "setectVale", "id", "label"],

  watch: {
    search(val) {
      if (!val) {
        return;
      }
      this.fetchEntriesDebounced(val);
    },

    id() {
      this.fetchEntriesDebounced('');
    }
  },

  mounted() {
    this.fetchEntriesDebounced("");
  },

  data: () => ({
    list: [],
    search: null,
  }),


  methods: {
    changeData(event) {
      this.$emit("changeData", event);
    },

    fetchEntriesDebounced(val) {
      clearTimeout(this._timerId);
      this._timerId = setTimeout(() => {
        let data = val;
        if (this.id && this.id != null) {
          data = { uuid: this.id, search: val };
        }
        this.$store
          .dispatch(this.$props.storeLink, data)
          .then((response) => {
            this.list = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => (this.isLoading = false));
      }, 500);
    },
  },
};
</script>
